import { render, staticRenderFns } from "./MyPrize.vue?vue&type=template&id=54633008&scoped=true"
import script from "./MyPrize.vue?vue&type=script&lang=js"
export * from "./MyPrize.vue?vue&type=script&lang=js"
import style0 from "./MyPrize.vue?vue&type=style&index=0&id=54633008&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54633008",
  null
  
)

export default component.exports